import { useContext, useState } from 'react';
import { Grid, TablePagination, Button, CircularProgress } from '@mui/material';
import { addOrdersContext } from './AddOrdersContext';
import { SearchType } from 'helpers/Enums';
import { CircleLoader } from 'components';
import Filters from './Filters';
import OrderResults from './OrderResults';
import WorkOrderResults from './WorkOrderResults';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';

let AddOrders = () => {
    let { formatMessage } = useIntl();

    let service = useContext(addOrdersContext);

    let [showAddOrders, setShowAddOrders] = useState(false);

    return (
        <>
            {showAddOrders === false &&
                <Grid item xs={12}>
                    <Grid container direction="row" spacing={1} alignItems={'center'} justifyContent={'center'}>
                        <Grid item>
                            <Button
                                variant="outlined"
                                onClick={() => setShowAddOrders(true)}
                            >
                                {formatMessage({ id: LocalizationIds.AddOrder })}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            }
            {showAddOrders === true &&
                <>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Filters />
                            </Grid>
                            {service.isSearching && <CircularProgress size={60} style={{ margin: 'auto' }} />}
                            {service.isSearching === false && service.isSearchDone === true &&
                                <>
                                    <Grid item xs={12}>
                                        {service.searchOrder.searchType === SearchType.Orders && <OrderResults />}
                                        {service.searchOrder.searchType === SearchType.WorkOrders && <WorkOrderResults />}
                                    </Grid>
                                    <Grid item xs style={{ paddingTop: 0 }}>
                                        <TablePagination
                                            component="div"
                                            count={service.recordCount}
                                            onPageChange={service.handleChangePage}
                                            page={service.searchOrder.pageNr}
                                            rowsPerPage={service.searchOrder.pageSize}
                                            rowsPerPageOptions={[service.searchOrder.pageSize]}
                                            labelDisplayedRows={({ page, count }) =>
                                                <>
                                                    {count}&nbsp;
                                                    {service.searchOrder.searchType === SearchType.Orders
                                                        ? formatMessage({ id: LocalizationIds.OrdersFound })
                                                        : formatMessage({ id: LocalizationIds.WorkOrdersFound })
                                                    }&nbsp;&middot;&nbsp;
                                                    {formatMessage(
                                                        { id: LocalizationIds.PageOf },
                                                        { pageNr: page + 1, count: Math.ceil(count / service.searchOrder.pageSize) }
                                                    )}
                                                </>
                                            }
                                        />
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs />
                    <Grid item>
                        <Button
                            variant="outlined"
                            onClick={() => { setShowAddOrders(false); service.resetSearch() }}
                        >
                            {formatMessage({ id: LocalizationIds.Close })}
                        </Button>
                    </Grid>
                </>
            }
        </>
    );
}

export default AddOrders;